export enum EthereumTokens {
    USDT = 'usdt',
    USDC = 'usdc',
    BUSD = 'busd'
}

export enum Blockhains {
    Ethereum = 'ethereum',
    Aptos = 'aptos'
}

export enum AptosTokens {
    Apt = 'apt'
}

export enum EthereumNetworks {
    Polygon = 'polygon',
    Ethereum = 'ethereum',
    Bsc = 'bsc',
    Arbitrum = 'arbitrum'
}

export enum Chains {
    Ethereum = 1,
    Polygon = 137,
    Bsc = 56,
    Arbitrum = 42161
}

export enum Allowance {
    Allowed = 'Allowed',
    NotAllowed = 'NotAllowed'
}